module.exports = __webpack_public_path__ + "static/GAuth-786ba77ca726d260dcfa6b9fa9157c12.png";